const styles = theme => ({
  icon: {
    fontSize: theme.typography.h2.fontSize,
    color: '#21C712',
  },
  iconRow: {
    marginRight: theme.spacing(1),
  },
})

export default styles
